// src/modules/app-views/crm/useUserRole.js
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import useZustand from 'hooks/useZustand';
import { test, USER_ROLE } from './roleConfig';

// *******************************************************************************
// HOOK
// *******************************************************************************
export function useUserRole() {
  const storedSubscription = useZustand('auth', 'subscription');
  // In dev with test=true, use the simulated USER_ROLE; otherwise use the real profile
  const role = test ? USER_ROLE : (storedSubscription?.profile || 'guest');

  return {
    role,
    isOwner: role === 'owner',
    isAdm: role === 'adm',
    isGuest: role === 'guest',
    // canManage: owner and adm bypass all board permission restrictions
    canManage: role === 'owner' || role === 'adm',
  };
}
